import { render, staticRenderFns } from "./ComponentYTPlayer.vue?vue&type=template&id=56306890&scoped=true&"
import script from "./ComponentYTPlayer.vue?vue&type=script&lang=js&"
export * from "./ComponentYTPlayer.vue?vue&type=script&lang=js&"
import style0 from "./ComponentYTPlayer.vue?vue&type=style&index=0&id=56306890&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56306890",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
